module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Add new")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }, [_c('div', {
    staticClass: "bg-blue-pale p-2 mt-3"
  }, [_vm._v("\n                Please note: This integration is exclusively available for OTAs that use the OCTO standard.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 pb-4"
  }, [_c('div', {
    staticClass: "create-octo-integration__fields--fixed-height row py-3"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Name"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.octo.name),
      expression: "octo.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.octo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.octo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.octo.name.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.octo.name.required) ? _c('span', [_vm._v("Name is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.octo.name.minLength) ? _c('span', [_vm._v("Name must have at least 5 characters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.octo.name.validCharacters) ? _c('span', [_vm._v("\n                            Invalid characters. Please use only letters and numbers.\n                        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Email"), _c('span', {
    staticClass: "brand ml-1"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.octo.email),
      expression: "octo.email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.octo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.octo, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.octo.email.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.octo.email.required) ? _c('span', [_vm._v("Email is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.octo.email.isEmailValid) ? _c('span', [_vm._v("Must be a valid email")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "disableConnectBtn": _vm.$v.octo.$invalid,
      "showConnectBtn": true,
      "loadingConnectBtn": _vm.isOctoConnecting
    },
    on: {
      "connectIntegration": function($event) {
        return _vm.connect()
      },
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8d9e260"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/createOctoIntegration.vue
// module id = 1982
// module chunks = 0